import { signal } from '@angular/core';
export const userDetailsSignal = signal<{
    userId?: string;
    workDayId?: string;
    firstName?: string;
  }>({});
export const userRoleMapngSignal = signal<{}>({});
export const userApplConfigSignal = signal<{
    plantName?: string;
    shopName?: string;
    lineName?: string;
    userId?: string;
    namc?: string;
    title?: string;
}>({});